import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppContextProvider } from './context/appContext';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import Config from './config';
import { getOrCreateUserId } from './utils/getOrCreateUserId';

Object.defineProperty(navigator, "userAgentData", {
  value: "web-client",
  configurable: true,
});

const userId = getOrCreateUserId();

const matomoInstance = createInstance({
  urlBase: Config.matomoURL, // WITHOUT "matomo.php" or "piwik.php"
  siteId: Config.matomoSiteID, // Your Matomo site ID
  trackerUrl: `${Config.matomoURL}matomo.php`,
  srcUrl: `${Config.matomoURL}matomo.js`,
  userId: userId,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <MatomoProvider value={matomoInstance}>
    <AppContextProvider>
    <App/>
    </AppContextProvider>
    </MatomoProvider>
  // </React.StrictMode>
);